import api from '@/utils/api.utils';

export interface TestScore {
  id: number;
  user_id: number;
  test_type: string;
  test_date: string | null;
  scores: Record<string, any>;
  total_score: number | null;
  is_official: boolean;
  created_at: string;
  updated_at: string;
}

export interface AdvancedCourse {
  id: number;
  user_id: number;
  course_type: string;
  subject: string;
  test_date: string | null;
  score: string;
  level: string | null;
  grade: string | null;
  created_at: string;
  updated_at: string;
}

export interface TestScoreCreate {
  test_type: string;
  test_date?: string | null;
  scores: Record<string, any>;
  total_score?: number | null;
  is_official?: boolean;
}

export interface AdvancedCourseCreate {
  course_type: string;
  subject: string;
  test_date?: string | null;
  score: string;
  level?: string | null;
  grade?: string | null;
}

export const testingService = {
  async getTestScores(): Promise<{ test_scores: TestScore[]; total_count: number }> {
    const response = await api.get('/api/v1/testing/test-scores');
    return response.data;
  },

  async createTestScore(data: TestScoreCreate): Promise<TestScore> {
    const response = await api.post('/api/v1/testing/test-scores', data);
    return response.data;
  },

  async deleteTestScore(testScoreId: number): Promise<void> {
    await api.delete(`/api/v1/testing/test-scores/${testScoreId}`);
  },

  async getAdvancedCourses(): Promise<{ advanced_courses: AdvancedCourse[]; total_count: number }> {
    const response = await api.get('/api/v1/testing/advanced-courses');
    return response.data;
  },

  async createAdvancedCourse(data: AdvancedCourseCreate): Promise<AdvancedCourse> {
    const response = await api.post('/api/v1/testing/advanced-courses', data);
    return response.data;
  },

  async createAdvancedCoursesBulk(courses: AdvancedCourseCreate[]): Promise<{ advanced_courses: AdvancedCourse[]; total_count: number }> {
    const response = await api.post('/api/v1/testing/advanced-courses/bulk', { courses });
    return response.data;
  },

  async updateAdvancedCourse(courseId: number, data: Partial<AdvancedCourseCreate>): Promise<AdvancedCourse> {
    const response = await api.put(`/api/v1/testing/advanced-courses/${courseId}`, data);
    return response.data;
  },

  async deleteAdvancedCourse(courseId: number): Promise<void> {
    await api.delete(`/api/v1/testing/advanced-courses/${courseId}`);
  },

  async getAPSubjects(): Promise<{ subjects: string[] }> {
    const response = await api.get('/api/v1/testing/ap-subjects');
    return response.data;
  },

  async getIBSubjects(): Promise<{ subjects: string[] }> {
    const response = await api.get('/api/v1/testing/ib-subjects');
    return response.data;
  },

  async getSATSubjectTests(): Promise<{ subjects: string[] }> {
    const response = await api.get('/api/v1/testing/sat-subject-tests');
    return response.data;
  },

  async getCambridgeSubjects(): Promise<{ subjects: string[] }> {
    const response = await api.get('/api/v1/testing/cambridge-subjects');
    return response.data;
  },
};

export default testingService;
